import * as actionType from "../constants";
import * as commonData from "../Common";
import action from "../Actions";

export const createattribute = (attr) => async (dispatch) => {
  dispatch({ type: actionType.ADDING_ATTRIBUTE });
  const apiurl = commonData.commonData().apiUrl;
  try {
    const resp = await fetch(`${apiurl}attribute/create`, {
      method: "post",
      body: JSON.stringify(attr),
    });
    const rdata = await resp.json();
    if (rdata.code === 200) {
      const newatt = attr.attributes[0];
      const newattr = { ...rdata.data[0] };
      const latattrn = {
        ...newattr,
        field: newattr.field,
        sortable: attr.attributes[0].sortable,
        filter: "agMultiColumnFilter",
        hide: attr?.attributes[0].hide,
        show_on_column: attr?.attributes[0].show_on_column,
        width: attr?.attributes[0].width,
      };
      let latenew;
      if (latattrn.attribute_type === "select") {
        let newva = [];
        latattrn.options.forEach((item) => {
          newva.push(item.option_name);
        });
        latenew = {
          ...latattrn,
          cellEditor: "agRichSelectCellEditor",
          cellEditorPopup: true,
          cellEditorParams: {
            cellHeight: 50,
            values: newva,
            cellEditorPopup: true,
          },
          popupPosition: "under",
        };
      } else {
        latenew = latattrn;
      }

      dispatch({ type: actionType.CREATE_ATTRIBUTE, payload: latenew });
      setTimeout(() => {
        dispatch({ type: actionType.ATTRIBUTE_POPUP_DEACTIVE });
      }, 4000);
    }
  } catch (error) {
    console.log(error);
  }
};

export const fetchAllcolumns = (inputs) => async (dispatch) => {
  const apiurl = commonData.commonData().apiUrl;
  // dispatch({ type: actionType.BOARD_MESSAGE_DEACTIVATE });
  dispatch({ type: actionType.CLEARING_ALL_COLUMNS });
  try {
    const response = await fetch(`${apiurl}tattle/list`, {
      method: "post",
      body: JSON.stringify({
        app_token: inputs.app_token,
        attribute_set_key: inputs.key,
        user_uuid: inputs.user_uuid,
      }),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      const { columns, rows } = rdata.data;

      dispatch({ type: actionType.REDIRECT_FALSE });
      dispatch({
        type: actionType.FETCH_DONE_FOR_COLUMNS,
        payload: {
          columns: columns || [],
          // rows: rows,
          hidden_count: rdata.data.hidden_column_count,
          hidden_columns: rdata.data.hidden_columns,
          board: false,
          users: rdata.data?.users,
        },
      });
    } else {
      dispatch({ type: actionType.REDIRECT_FALSE });
      dispatch({ type: actionType.DATA_NOT_FOUND, payload: [] });
    }
    return rdata;
  } catch (error) {
    console.log(error);
  }
};

export const fetchAllRows =
  (inputs, update = null) =>
  async (dispatch) => {
    const apiurl = commonData.commonData().apiUrl;
    dispatch({ type: actionType.FETCHING_ALL_COLUMNS });
    dispatch({ type: actionType.BULK_UPDATE_PROCESS });
    try {
      const response = await fetch(`${apiurl}tattle/rows`, {
        method: "post",
        body: JSON.stringify({
          app_token: inputs.app_token,
          attribute_set_key: inputs.key,
        }),
      });

      const rdata = await response.json();
      if (rdata.code === 200) {
        const { data } = rdata;
        dispatch({ type: actionType.REDIRECT_FALSE });
        dispatch({
          type: actionType.FETCH_DONE_FOR_ROWS,
          payload: {
            rows: data,
            board: false,
            update: update,
          },
        });
        setTimeout(() => {
          dispatch({ type: actionType.ATTRIBUTE_MESSAGE_DEACTIVATE });
        }, 4000);
      } else {
        dispatch({ type: actionType.REDIRECT_FALSE });
        dispatch({ type: actionType.DATA_NOT_FOUND, payload: [] });
      }
    } catch (error) {
      console.log(error);
    }
  };
